//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/produtos/:category',
      en: '/products/:category',
      es: '/productos/:category'
    }
  },

  async asyncData({ $api, params }) {
    try {
      // Get categories
      const { category: slug } = params
      const { category, sub_categories } = await $api.products.category(slug)

      // Handle medias
      if (category.main_image) {
        category.medias = [category.main_image, ...category.medias]
      }

      return {
        category,
        sub_categories
      }
    } catch (err) {
      $api.instance.handleResponseError(err)
    }
  },

  data() {
    return {
      category: {},
      sub_categories: []
    }
  },

  head() {
    const { title, seo, main_image } = this.category

    return this.$helpers.seoBuilder(this, {
      staticTitle: `${this.$t('title')} - ${seo ? seo.title : title}`,
      staticDescription: seo.description || '',
      ogImage: main_image ? main_image.url : null,
      ogImageWidth: main_image ? 645 : null,
      ogImageHeight: main_image ? 359 : null
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('title'),
          path: '/produtos'
        },
        {
          name: this.category.title,
          path: this.$route.fullPath
        }
      ]

      return breadcrumbs
    }
  }
}
